import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=231e0320"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=231e0320&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports